<template>
  <footer class="bg-gray-800">
    <TContainer class="py-12 xl:py-16">
      <div class="grid gap-x-4 grid-cols-2 xl:grid-cols-4">
        <MenuFooterLinks />
      </div>
      <TSeparator color-classes="border-gray-600" class="my-8 xl:my-14" />
      <div class="grid gap-x-4 grid-cols-1 xl:grid-cols-2">
        <MenuFooterApps />
        <MenuFooterSocial />
      </div>
    </TContainer>
  </footer>
</template>
